(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('components/timer-popup.html', '<div class=\"feedback_modal\">\n	<div class=\"feedback_modal_inner\">\n	<div class=\"feedback_content\">\n		<h2 ng-bind-html=\"content.title\"></h2>\n		<p ng-bind-html=\"content.text\"></p>\n    <a ng-click=\"next()\" class=\"btn\" ng-class=\"{\'is-focus\' : slideObj.continue === true}\" ng-show=\"next\" ng-hide=\"lastSlide\"><span>Verder</span></a>\n\n	</div>\n	<button class=\"feedback_close btn btn--close\" ng-click=\"close()\"><span>Sluit venster</span></button>\n</div>\n');
    }]);
})();